const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Variant label for a Fender SKU row. FMIC's skuDisplayName is usually
 * "<productDisplayName>, <VOLTAGE> <COUNTRY>" (e.g. "Tone Master® FR-10, 230V UK"). Returns the suffix
 * when title is a prefix followed by "," or " - "; the full skuDisplayName when it just
 * differs from title; "" when missing, empty, or identical to title.
 */
export function fenderMarketLabel(title: string | undefined, skuDisplayName: string | undefined): string {
  const name = (skuDisplayName || "").trim();
  const t = (title || "").trim();
  if (!name || name === t) return "";
  if (t) {
    const suffix = name.match(new RegExp(`^${escapeRegExp(t)}(?:,\\s*| - )(.+)$`))?.[1]?.trim();
    if (suffix) return suffix;
  }
  return name;
}
